// Dateをdatetime-local用の文字列(YYYY-MM-DDTHH:mm)へ変換する。
export const toDateTimeLocalValue = (date: Date) => {
  const tzOffsetMs = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - tzOffsetMs).toISOString().slice(0, 16);
};

// datetime-localの文字列をDateへ変換する（不正値はnull）。
export const parseDateTimeLocal = (value: string): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

// APIリクエスト用のローカル日時文字列(YYYY-MM-DD HH:mm:ss)を生成する。
export const formatLocalDateTimeForRequest = (date: Date) => {
  const pad2 = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(
    date.getDate(),
  )} ${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(
    date.getSeconds(),
  )}`;
};

// ISOタイムスタンプを表示用ラベルへ整形する（必要に応じて日付も付ける）。
export const formatTimeLabel = (
  timestamp: string,
  showDate: boolean,
  shortYear: boolean = false,
) => {
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return timestamp.slice(11, 19);
  const pad2 = (n: number) => String(n).padStart(2, "0");
  const hhmmss = `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(
    d.getSeconds(),
  )}`;
  if (!showDate) return hhmmss;
  const year = shortYear
    ? pad2(d.getFullYear() % 100)
    : String(d.getFullYear());
  return `${year}/${pad2(d.getMonth() + 1)}/${pad2(d.getDate())} ${hhmmss}`;
};
